import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'stringDateFormatter'
})
export class StringDateFormatterPipe implements PipeTransform {

  transform(value: string, inFormat: string = 'YYYY-MM-DD', outFormat: string = environment.DATE_OUTPUT_FORMAT): unknown {
    if (!value || value === '')
      return '';

    if (!inFormat) {
      inFormat = 'YYYY-MM-DD';
    }

    if (!outFormat) {
      outFormat = environment.DATE_OUTPUT_FORMAT;
    }

    return moment(value, inFormat).format(outFormat);
  }

}
